import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

export default function AdminRoute({ component: Component, render, ...rest }) {
  //REDUX STATE - ADMIN USER LOGIN
  const adminUserToLogin = useSelector((state) => state.adminUserToLogin);
  const { adminUserInfo } = adminUserToLogin;

  return (
    <Route
      {...rest}
      render={(props) =>
        adminUserInfo ? (
          render ? (
            render(props)
          ) : (
            <Component {...props}></Component>
          )
        ) : (
          <Redirect to="/admin-giris" />
        )
      }
    ></Route>
  );
}
